import { render, staticRenderFns } from "./StadiumFieldUpdateForm.vue?vue&type=template&id=4e6d058c&"
import script from "./StadiumFieldUpdateForm.vue?vue&type=script&lang=js&"
export * from "./StadiumFieldUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6d058c')) {
      api.createRecord('4e6d058c', component.options)
    } else {
      api.reload('4e6d058c', component.options)
    }
    module.hot.accept("./StadiumFieldUpdateForm.vue?vue&type=template&id=4e6d058c&", function () {
      api.rerender('4e6d058c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumFieldUpdateForm.vue"
export default component.exports